import { render, staticRenderFns } from "./MediaCard.vue?vue&type=template&id=2aec9112&scoped=true&"
import script from "./MediaCard.vue?vue&type=script&lang=js&"
export * from "./MediaCard.vue?vue&type=script&lang=js&"
import style0 from "./MediaCard.vue?vue&type=style&index=0&id=2aec9112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aec9112",
  null
  
)

export default component.exports